import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const BoredIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
      <path
        fill="#664500"
        d="M23 40c2.8 0 5-3.1 5-7s-2.2-7-5-7-5 3.1-5 7 2.2 7 5 7ZM49 40c2.8 0 5-3.1 5-7s-2.2-7-5-7-5 3.1-5 7 2.2 7 5 7ZM24 56c4-10 26-10 26-6 0 2-16-2-26 6Z"
      />
    </Icon>
  );
};

export default BoredIcon;
